// @flow
import moment from 'moment'
import Path from 'routes/path'
import { type Owner } from 'types/v1/reservation'

export function getReservationHostSectionProps(owner: Owner) {
  return {
    ownerPageHref: Path.owner(owner.username || ''),
    ownerName: owner.corp_name || owner.name || '',
    topHost: owner.rank === 1,
    ownerImageSrc: owner.profile_image || '',
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/ReservationHostSection/presenter.js